import { modelLoadingAtom } from '@/atoms';
import { LoadingBadge } from '@/components/ui/LoadingBadge';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

/**
 * Badge rows for fragment (IFC) model layers: download progress, then
 * "building geometry" until the fragments worker stops streaming tiles in,
 * and "loading detail" for long bursts after a zoom or pan. Without this a
 * big model shows a few scattered tiles with gaps for several seconds and
 * reads as broken. Entries are driven by `IFC2` via `modelLoadingAtom`.
 *
 * Renders rows only — `ViewerLoadingColumn` positions and stacks it with the
 * other loaders.
 */
export const ModelLoadingOverlay = () => {
  const { t } = useTranslation('project');
  const loading = useAtomValue(modelLoadingAtom);
  const entries = Object.values(loading);
  if (entries.length === 0) return null;

  return (
    <>
      {entries.map((e) => (
        <LoadingBadge
          key={e.layerId}
          name={e.layerName}
          phase={e.phase}
          progress={e.progress}
          loadedBytes={e.loadedBytes}
          totalBytes={e.totalBytes}
          error={e.error}
          labels={{
            fetching: t('modelLoader.fetching'),
            decoding: e.stage === 'refine' ? t('modelLoader.refining') : t('modelLoader.building'),
            failed: t('modelLoader.failed'),
          }}
        />
      ))}
    </>
  );
};
